export enum IssueNameErrors {
  IssueSingularNameRequired = 'IssueSingularNameRequired',
  IssuePluralNameRequired = 'IssuePluralNameRequired'
}
